import { NavItem } from "../../vertical/sidebar/nav-item/nav-item";

export const navItems: NavItem[] = [
  {
    navCap: "Home",
  },
  {
    displayName: "Dashboard",
    iconName: "home",
    route: "/dashboard",
  },
  {
    navCap: "Stores",
  },
  {
    displayName: "Stores",
    iconName: "shopping-cart",
    route: "/store/stores",
  },
  {
    displayName: "Cases",
    iconName: "checklist",
    route: "/store/cases",
  },
  {
    displayName: "Claims",
    iconName: "box-multiple",
    route: "/store/claims",
  },
  {
    displayName: "COGS",
    iconName: "calculator",
    route: "/store/cogs",
  },
  {
    navCap: "Claims",
  },
  {
    displayName: "Damaged Inventory",
    iconName: "package-off",
    route: "/claim/damaged-inventory",
  },
  {
    displayName: "Refund Never Returned Claim",
    iconName: "package-off",
    route: "/claim/refund-never-returned-claim",
  },
  {
    displayName: "Reanalysis",
    iconName: "package-off",
    route: "/claim/reanalysis",
  },
  {
    displayName: "Lost Inbound (Guide)",
    iconName: "info-circle",
    route: "/claim/lost-inbound-guide",
  },
  {
    navCap: "Reports",
  },
  {
    displayName: "Cases",
    iconName: "chart-line",
    route: "/report/cases",
  },
  {
    displayName: "Claims",
    iconName: "chart-area",
    route: "/report/claims",
  },
  {
    navCap: "Help Center",
  },
  {
    displayName: "FAQs",
    iconName: "help",
    route: "/help/faqs",
  },
  {
    displayName: "Guides",
    iconName: "note",
    route: "/help/guides",
  },
  {
    displayName: "Support",
    iconName: "mail",
    route: "/help/support",
  },
];
